var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PWidgetHeader',{attrs:{"icon":"globe"}},[_c('PTranslation',{attrs:{"k":"PEnvironmentWidget.Environment"}})],1),_c('div',{staticClass:"flex flex-col space-y-4 mt-2"},[_c('highcharts',{attrs:{"options":_vm.fillTrend}}),_c('highcharts',{attrs:{"options":_vm.reuseTrend}}),_c('highcharts',{attrs:{"options":_vm.emissionTrend}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }